import { ChevronLeftIcon, ChevronRightIcon } from '@fluentui/react-icons-mdl2';
import { Carousel, Empty } from 'antd';
import { CarouselRef } from 'antd/lib/carousel';
import { useEffect, useRef, useState } from 'react';
import { AuctionResponse, StartStatus } from '../../auction/types';
import ItemCard from '../../common/components/ItemCard';
import { ItemCardStatus } from '../../common/types/types';
import SlickButton from './SlickButton';

interface ItemCarouselProps {
    items: AuctionResponse[],
    reloadPage: () => void,
    onViewMoreClick?: () => void,
    totalElements: number,
    emptyMessage?: string,
    numOfItems?: number,
}

const ItemCarousel = ({ items, reloadPage, totalElements, emptyMessage, numOfItems = 4 }: ItemCarouselProps) => {
    const carousel = useRef<CarouselRef>(null);
    
    const getCardStatus = (item: AuctionResponse) => {
        let status = ItemCardStatus.SUCCESS;

        switch (item?.startStatus) {
            case StartStatus.UPCOMING:
                status = ItemCardStatus.NEW;
                break;
            case StartStatus.ONGOING:
                status = ItemCardStatus.INPROGRESS;
                break;
            case StartStatus.PAUSE:
                status = ItemCardStatus.PAUSE;
                break;
            case StartStatus.FINISH:
                status = ItemCardStatus.SUCCESS;
                break;
            default:
                status = ItemCardStatus.NEW;
                break;
        }

        if (item?.bidderAcceptBid?.status === 3) {
            status = ItemCardStatus.FAILED;
        }

        return status;
    }

    return (
        <>
            {/* {totalElements > numOfItems ?
                <div
                    style={{ textAlign: 'right', marginRight: '30vw', width: '100%', fontSize: 16, marginTop: 20 }}
                    className="anchor-text"
                    onClick={onViewMoreClick}>
                    Xem thêm
                </div> : <></>} */}
            <div className="responsive-padding-1440" style={{display: 'flex', justifyContent: 'center'}}>
                <div className="item-carousel">
                    {items.length > 1 &&
                        (
                            <Carousel
                                style={{ marginRight: -50, marginLeft: -50 }}
                                slidesToShow={items.length > numOfItems ? numOfItems : items.length}
                                slidesToScroll={1}
                                ref={carousel}
                                arrows={true}
                                prevArrow={<SlickButton className="item-carousel-arrow"><ChevronLeftIcon /></SlickButton>}
                                nextArrow={<SlickButton className="item-carousel-arrow"><ChevronRightIcon /></SlickButton>}>
                                {items.map((item, index) => {
                                    return (
                                        <div key={index}>
                                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                <ItemCard
                                                    status={getCardStatus(item)}
                                                    item={item}
                                                    reloadPage={reloadPage} />
                                            </div>
                                        </div>
                                    )
                                })}
                            </Carousel>)}
                    {items.length === 1 &&
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <ItemCard
                                status={getCardStatus(items[0])}
                                item={items[0]}
                                reloadPage={reloadPage} />
                        </div>}

                    {!items.length &&
                        <div style={{ textAlign: 'center', fontSize: 22 }}>{emptyMessage || "Hiện không có tài sản đang được đấu giá"}</div>}
                </div>
            </div>
        </>
    )
}

export default ItemCarousel